import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import CarouselBox from 'components/CarouselBox';

import ArticleCard from './ArticleCard';

const SHOW_ARROWS_THRESHOLD = 3;

const HighlightedArticles = ({ articles, gaEventCategory, title = null }) => (
  <section>
    {title && (
      <Heading className="mb-8 text-center" size="size4">
        {title}
      </Heading>
    )}
    <CarouselBox
      arrowsProps={{
        className: 'hidden lg:flex',
        offsetX: { left: '-left-2', right: '-right-2' },
      }}
      dotsProps={{ className: 'lg:hidden' }}
      itemProps={{
        itemSize: 96,
        slidesPerView: 1,
        breakpoints: {
          md: { slidesPerView: 2, itemSize: 90 },
          lg: { slidesPerView: 3, itemSize: 96 },
          xl: { slidesPerView: 3, itemSize: 98 },
        },
      }}
      list={articles}
      render={(article) => (
        <ArticleCard
          key={article.id}
          articleSlug={article.slug}
          articleThumbnail={article.thumbnail}
          articleTitle={article.title}
          gaEventCategory={gaEventCategory}
        />
      )}
      showArrows={articles.length > SHOW_ARROWS_THRESHOLD}
      dots
      full
    />
  </section>
);

HighlightedArticles.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default HighlightedArticles;
